import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useEffect, useState, useRef } from 'react';
import UserGoBack from "../../user/UserGoBack";
import TagsAnchorContainer from "../TagsAnchorContainer";
import ArticleUtile from "../ArticleUtile";
import RightPartContent from "../RightPartContent";
import { useSectionRefs } from "../../../hooks/useSectionRefs";

const HelpTopicSecurePwd = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { anchorsParts, topic, isLoading, LoadingComponent } = useSectionRefs();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Votre compte', link: '/topics/compte'},
    { label: 'Sécurité du compte', link: '/topics/compte/securite'},
    { label: topic.title, link: topic.link},
  ]


  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Pour créer un mot de passe sûr, plus il y a de caractères spéciaux et de chiffres, mieux c'est. 
              Voici comment créer un mot de passe sûr pour protéger votre compte. Si vous oubliez votre mot de passe, vous pouvez toujours le 
              <a target='_blank' className="link" href="/topics/compte/8">réinitialiser.</a>
            </p>
            <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/>
            <div className="article-container mt-40" ref={anchorsParts[0].ref}>
              <p className="help-title-part">{anchorsParts[0].content}</p>
              <p className="help-text">
                Dans l'idéal, votre mot de passe Wodzone ne doit pas être celui que vous utilisez sur d'autres sites web, notamment pour accéder à 
                votre messagerie, vos comptes bancaires en ligne ou vos comptes sur les réseaux sociaux. Ainsi, les problèmes de sécurité sur ces 
                sites sont moins susceptibles d'affecter votre compte Wodzone.
              </p>
              <p className="help-text">À faire :</p>
              <ul className="mb-6">
                <li className="pl-8 mb-16">
                  <p className="help-text">Utiliser une combinaison de lettres, de chiffres et de caractères spéciaux (par exemple, #, $, !).</p>
                </li>
                <li className="help-text pl-8 mb-8">
                  <p className="help-text">
                    Remplacer certaines des lettres par des chiffres et des caractères spéciaux.<br/>
                    Par exemple, au lieu du mot de passe « BarbellSquat », essayez d'utiliser « B@r8el1$qu@t ». 
                  </p>
                </li>
              </ul>
              <p className="help-text mt-32">À ne pas faire :</p>
              <ul className="mb-6">
                <li className="help-text pl-8 mb-8">
                  <p className="help-text">Utiliser des mots courants.</p>
                </li>
                <li className="help-text pl-8 mb-8">
                  <p className="help-text">Utiliser une combinaison mot + chiffre (par exemple, dumbell1).</p>
                </li>
              </ul>
              <p className="help-text mt-24">Conseil : plus votre mot de passe est long, plus il est difficile à deviner.</p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[1].ref}>
              <p className="help-title-part mb-8">{anchorsParts[1].content}</p>
              <p className="help-text">
                Si vous trouvez difficile de vous rappeler vos mots de passe, essayez un gestionnaire de mots de passe. C'est la solution idéale pour stocker 
                et organiser les mots de passe de chacun de vos comptes en ligne afin d'éviter de devoir tous les mémoriser.
              </p>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicSecurePwd